import React from "react";
import "./Order_Process_OrderSummary.css";
import { Form, Table } from "react-bootstrap";
import Orange_Round_Arrow_Btn from "../../../Common-Component/Common_Btn/Orange_Round_Arrow_Btn/Orange_Round_Arrow_Btn";
import AddedToCartModal from "../../../Common-Component/Common_Modal/AddedToCartModal/AddedToCartModal";
import { useDispatch } from "react-redux";
import { addToCard } from "../../../../features/cart/cartSlice";
import { useForm } from "react-hook-form";

function Order_Process_OrderSummary({ data }) {
  const [modalShow, setModalShow] = React.useState(false);
  const dispatch = useDispatch();
  const { register, handleSubmit, watch } = useForm();
  const onSubmit = async (d) => {
    // if()
    const formData = new FormData();
    formData.append("product_id", data.product.id);
    formData.append("combination_id", data.combination.id);
    formData.append("additional_informattion", d.additional_informattion);
    formData.append("design_instruction", data.design_instruction);
    for (let i = 0; i < data.files.length; i++) {
      formData.append("file", data.files[i]);
    }

  

    const res = await dispatch(addToCard(formData));
    setModalShow(true);
    // if (res?.payload?.errors) {
    //     setError("pincode", {
    //         type: "manual",
    //         message: res.payload?.errors,
    //       });
    //   }else{
    //     setshowUploadModal(true);
    //   }
  };
  return (
    <>
      <div className="Order_Process_OrderSummary">
        <div className="Order_Process_card_half">
          <div className="heading_holder">
            <h4>Order Summary</h4>
          </div>

          <div className="OrderSummary_table_holder">
            <Table borderless>
              <tbody>
                <tr>
                  <td>
                    Per piece cost{" "}
                    <span className="small-text">(Inclusive taxes)</span>
                  </td>
                  <td className="text-end">
                    ₹{(Number(data?.combination?.per_piece) || 0).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td>Quantity</td>
                  <td className="text-end">{data?.combination?.Qty?.name}</td>
                </tr>
                <tr>
                  <td>Total Production Charges</td>
                  <td className="text-end">
                    ₹{(Number(data?.combination?.total) || 0).toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="Order_Process_card_half field_holder_card">
            <div className="field_holder">
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Control
                  as="textarea"
                  placeholder="Enter Any Additional Information About Your Order (Optional)"
                  {...register("additional_informattion")}
                />
              </Form.Group>
            </div>
            {/* <div onClick={() => setModalShow(true)}> */}
            <div>
              <Orange_Round_Arrow_Btn
                btn_name={"Add To Cart"}
                type={"submit"}
              />
            </div>
          </div>{" "}
        </Form>
      </div>

      <AddedToCartModal show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
}

export default Order_Process_OrderSummary;
